var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCompetitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 48,
    viewBox: "0 0 53 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4539 13.0879C39.6297 4.22302 30.9645 -1.48459 22.0996 0.339558C14.5087 1.90161 9.04999 8.56758 9.01517 16.3173C9.01517 16.6865 9.03043 17.0646 9.06321 17.4644C3.66297 18.036 -0.25142 22.8772 0.320201 28.2774C0.850033 33.2828 5.07425 37.0799 10.1076 37.075H11.2547C11.2285 36.7123 11.2002 36.3518 11.2002 35.9824C11.2002 28.1386 17.5589 21.7798 25.4028 21.7798C33.2467 21.7798 39.6053 28.1386 39.6053 35.9824C39.6053 36.3517 39.577 36.7122 39.5507 37.075H40.6979C47.3277 37.0931 52.717 31.7332 52.7351 25.1033C52.7525 18.7417 47.8041 13.4712 41.4539 13.0879Z",
    fill: "#DADADA",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4023 48C32.0394 48 37.4199 42.6195 37.4199 35.9824C37.4199 29.3453 32.0394 23.9648 25.4023 23.9648C18.7652 23.9648 13.3848 29.3453 13.3848 35.9824C13.3848 42.6195 18.7652 48 25.4023 48Z",
    fill: "#3176BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4031 43.6311C24.7997 43.6311 24.3105 43.142 24.3105 42.5386V29.4285C24.3105 28.8251 24.7997 28.3359 25.4031 28.3359C26.0065 28.3359 26.4956 28.8251 26.4956 29.4285V42.5386C26.4955 43.142 26.0065 43.6311 25.4031 43.6311Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7722 34.8898C29.6286 34.89 29.4864 34.862 29.3537 34.8072C29.221 34.7525 29.1003 34.6721 28.9987 34.5707L25.4021 30.972L21.8056 34.5707C21.3716 34.9899 20.6799 34.9778 20.2607 34.5439C20.064 34.3402 19.954 34.0681 19.954 33.7849C19.954 33.5017 20.064 33.2296 20.2607 33.0259L24.6308 28.6558C25.0574 28.2293 25.7489 28.2293 26.1756 28.6558L30.5457 33.0259C30.9717 33.4532 30.9706 34.1449 30.5432 34.5709C30.3385 34.775 30.0613 34.8897 29.7722 34.8898Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCompetitor);
export default __webpack_public_path__ + "static/media/Upload-Competitor.c270d561311e7e80ccd5708ce76232cb.svg";
export { ForwardRef as ReactComponent };